import { FC } from 'react';
import styles from './style.module.css';

import { MedicalInstitutionIntroCard } from '../MedicalInstitutionIntroCard/MedicalInstitutionIntroCard';
import { MedicalInstitutionIntroCardSection } from '../MedicalInstitutionIntroCardSection/MedicalInstitutionIntroCardSection';
import { FragmentType, useFragment } from 'gen/medinavi-backend-consumer-graphql';
import { Markdown } from '~/components/elements/Markdown/Markdown';
import { MedicalInstitutionInformationCardFragmentDoc } from 'gen/medinavi-backend-consumer-graphql/graphql';
import { MessageFromUbieAimon } from '~/components/features/medical-institution/MessageFromUbieAimon';

type Props = {
  institution: FragmentType<typeof MedicalInstitutionInformationCardFragmentDoc>;
};

export const MedicalInstitutionInformationCard: FC<Props> = ({ institution: institutionFragment }) => {
  const institution = useFragment(MedicalInstitutionInformationCardFragmentDoc, institutionFragment);

  return (
    <MedicalInstitutionIntroCard title="医療機関の情報">
      {institution.address && (
        <MedicalInstitutionIntroCardSection title="住所">{institution.address}</MedicalInstitutionIntroCardSection>
      )}
      {institution.telephoneNumber && (
        <MedicalInstitutionIntroCardSection title="電話番号">
          {institution.telephoneNumber}
          {institution.telephoneReceptionNote && (
            <div className={styles.note}>
              <Markdown>{institution.telephoneReceptionNote}</Markdown>
            </div>
          )}
        </MedicalInstitutionIntroCardSection>
      )}
      <MedicalInstitutionIntroCardSection title="診療時間">
        {institution.amOpenTime && institution.pmOpenTime ? (
          <>
            <p>
              午前：{institution.amOpenTime}〜{institution.amCloseTime}
            </p>
            <p>
              午後：{institution.pmOpenTime}〜{institution.pmCloseTime}
            </p>
          </>
        ) : (
          '医療機関に直接ご確認ください'
        )}
        <MessageFromUbieAimon style={'no-margin-left'} />
      </MedicalInstitutionIntroCardSection>
      <MedicalInstitutionIntroCardSection title="休診">
        {institution.closeDays ? institution.closeDays : '医療機関に直接ご確認ください'}
      </MedicalInstitutionIntroCardSection>
      {institution.characteristic && (
        <MedicalInstitutionIntroCardSection title="特徴">
          {institution.characteristic}
        </MedicalInstitutionIntroCardSection>
      )}
    </MedicalInstitutionIntroCard>
  );
};
